import classes from './Wishlist.module.scss'
import EmptyWishlist from '../../../assets/EmptyWishlist.png'
import TestImageSmall from '../../../assets/SampleThumbnailImage.png'
import CrossChevron from '../../../assets/icons/CrossChevron.svg';
import { useEffect, useState } from 'react';
import { ProductService } from '../../../services/ProductService';
import { globalErrorHandler } from '../../../utils/errorHandler';
import { useLoader } from '../../../customHooks/loader';
import { useNavigate } from 'react-router-dom';
export default function Wishlist() {

  const [wishlistProducts, setWishlistProducts] = useState([]);

  const loader = useLoader();
  const navigate = useNavigate();

  useEffect(() => {
    handleGetWishlistProducts();
  }, [])

  const handleGetWishlistProducts = () => {
    ProductService.getWishlistProducts(
      handleGetWishlistProductSuccess,
      globalErrorHandler,
      loader,
    )
  }

  const handleGetWishlistProductSuccess = ({ data }) => {
    console.log(data.data);
    setWishlistProducts(data.data.wishlist);
  }


  const deleteCartProduct = (itemId) => {
    ProductService.editWishlistProducts(
      { id: itemId, operation: "remove" },
      handleWishlistOperationSuccess,
      globalErrorHandler,
      loader,
    )
  }

  const handleWishlistOperationSuccess = ({data}) => {
    handleGetWishlistProducts();
  }

  return (
    <div className={classes.Wishlist}>
      {!wishlistProducts.length ?
        (

          <div className={classes.EmptyCart}>
            <img src={EmptyWishlist} className={classes.EmptyCartImage} alt='cart is empty' />
            <div className={classes.EmptyCartTitle}>Your wishlist is empty.</div>
            <div className={classes.EmptyCartSubTitle}>You don't have any products in the wishlist yet. You will find a lot
              of interesting products on our Shop page.</div>
            <div className={classes.EmptyCartContinueShopping} onClick={() => navigate('/products')}>Continue Shopping</div>
          </div>
        ) : (
          <div className={classes.WishlistItems}>
            <div className={classes.Heading}>Wishlist</div>
            <div className={classes.SummaryContainer}>
              <div className={classes.ProductSummaryContainer}>
                {wishlistProducts.map((product) => (
                  <div className={classes.ProductSummary}>
                    <img onClick={() => deleteCartProduct(product.productId)} src={CrossChevron} alt='delete wishlist item' className={classes.DeleteIcon} />
                    <div className={classes.ProductDetailsContainer}>
                      <img src={product.productImage} alt='product' />
                      <div className={classes.ProductDetails}>
                        <div>{product.productName}</div>
                        {/* <div>Color :<span className={classes.ProductDetailsSubText}>&nbsp; {product.itemColor}</span></div> */}
                      </div>
                    </div>
                    <div className={classes.ProductPrice}> د.إ {product.productPrice}</div>
                    <div className={classes.AddToCart}>Add to cart</div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}
    </div >
  )
}
